import { initAccordion } from './script/accordion.js';
import { initFormFeedback } from './script/form-feedback.js';
import { initHeader } from './script/header.js';
import { initProjectSlider, initHeroSlider } from './script/slider.js';
import { initReveal } from './script/reveal.js';
import { initPreloader } from './script/preloader.js';

document.documentElement.classList.add('js');

initPreloader();
initHeader();
initReveal();
initAccordion();
initProjectSlider();
initHeroSlider();
initFormFeedback();
